/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Submit_Dialog_DescInputs */

const vi_stocktake_submit_dialog_desc = /** @type {(inputs: Stocktake_Submit_Dialog_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn sắp submit phiếu kiểm:`)
};

/**

* @param {Stocktake_Submit_Dialog_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_submit_dialog_desc = /** @type {((inputs?: Stocktake_Submit_Dialog_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Submit_Dialog_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_submit_dialog_desc(inputs)
});